import PropTypes from 'prop-types';

const ProductStatuses = ({ product, tags, statuses, discount }) => {
	const discountTagBackColor = () => {
		// if (product.dsc < 30) {
		// 	return '#0154FF';
		// } else {
		return '#FF0145';
		// }
	};

	if (!product) return <></>;

	return (
		<div className="tags-container">
			{/* Display below if product has % sale. */}
			<div className="discount-container">
				{tags?.map((tag, index) => (
					<span key={index} className="discount-tag" style={{ color: '#fff', backgroundColor: tag.chex ?? '#0154ff' }}>
						{tag.snm}
					</span>
				))}
			</div>
			{/* Display below if product has "New" checked. */}
			{statuses && (
				<div className="new-container">
					{statuses
						.filter(status => status === 'Νεο Προιον')
						.map((status, index) => (
							<span key={index} className="tag-new" style={{ color: '#fff', backgroundColor: '#0154ff' }}>
								NEW
							</span>
						))}
				</div>
			)}

			{/* Display below if product has statuses checked other than "New". */}
			{statuses && (
				<div className="statuses-container">
					{statuses
						.filter(status => status !== 'Νεο Προιον')
						.map((status, index) => (
							<span key={index} className="tag" style={{ color: '#fff', backgroundColor: '#0154ff' }}>
								{status}
							</span>
						))}
				</div>
			)}
		</div>
	);
};

ProductStatuses.propTypes = {
	product: PropTypes.object,
	tags: PropTypes.array,
	statuses: PropTypes.array,
	discount: PropTypes.any
};

export default ProductStatuses;
